import React, { Component } from 'react';
import {
  Popconfirm,
  message,
  Divider,
  Table,
  Form,
  Icon,
  Input,
  Button,
  Card,
  Row,
  Col,
  Spin,
  DatePicker,
  Popover,
} from 'antd';
import { Link } from 'react-router-dom';
import { } from 'react-router';
import client from '../../feathers';
import requireAuth from "../../components/requireAuth";
import Layout from "../../components/layout";
import DebitNotesForm from "../../components/debitnotes-supplier/form";
import moment from 'moment';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchDebitNotes,
  pushDebitNotes,
  removeDebitNotes,
  updateMode,
  updateActiveDebitNotes,
  updateDebitNotes
} from '../../actions/actions-debitnotes';

const _ = require('lodash');
const PAGESIZE = 20;
const text = 'Are you sure to delete this item?';

class DebitNotesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      totalPagination: 1,
      CurrentPagination: 1,
      searchReferenceNo: '',
      searchStatus: '',
      searchDate: '',
      dtAccountList: [],
      ctAccountList: [],
      _id: '',
    }

    this.handleDelete = this.handleDelete.bind(this);
    this._searchReferenceNoChange = this._searchReferenceNoChange.bind(this);
    this._searchDateChange = this._searchDateChange.bind(this);
  }

  componentDidUpdate() {

    if (this.props.debitnotes.mode === 'refresh') {
      this.componentWillMount()
    }
  }

  componentDidMount() { }

  componentWillMount() {

    this.props.updateMode('')
    this.setState({ loading: true });

    client.authenticate().then((res) => {
      //
      return client.service('debitnotes').find({
        query: {
          $populate: 'propertyunitId dtledgerAccountId ctledgerAccountId',
          companyId: this.props.commons.selectedCompany._id,
          $limit: PAGESIZE,
          divisionType: 'SUPPLIER',
          $sort: {
            createdAt: -1
          }
        }
      })
    }).then((res) => {

      this.props.fetchDebitNotes(res.data);
      this.setState({ totalPagination: res.total, loading: false });
    }).catch((err) => {
      console.log(err);
      this.setState({
        loading: false,
      });
    })

    this.getAccountList()
  }

  handleDelete(_id) {
    axios.post(`${client.io.io.uri}removeTrx`, {
      _id: _id,
      companyId: this.props.commons.selectedCompany._id,
      trxType: 'DN'
    }, {
      headers: {
        'Authorization': client.settings.storage.storage['feathers-jwt']
      }
    }).then((res) => {
      message.success('Deleted');
      this.props.updateMode('refresh')
    }).catch((err) => {
      console.log(err);
      this.props.updateMode('refresh')
    })
  }

  handleEdit(_id) {
    this.props.updateActiveDebitNotes('edit', _id)

  }

  handleManage(_id) {
    this.props.updateActiveDebitNotes('', _id)
  }

  showModal = () => {
    this.props.updateActiveDebitNotes('', '')
    this.props.updateMode('new')

  }

  renderConfirmDeleteBtn(_id) {
    return (<Popconfirm placement="topLeft" title={text} onConfirm={() => this.handleDelete(_id)} okText="Confirm" cancelText="Cancel">
      <Button type="danger">Delete</Button>
    </Popconfirm>)
  }

  _searchReferenceNoChange(e) {
    this.setState({
      searchReferenceNo: e.target.value,
      searchObj: _.merge(
        this.state.searchObj, e.target.value
        ? {
          referenceId: e.target.value
        }
        : {
          referenceId: '.'
        }),
      typingTimeout: setTimeout(() => {
        this._getData(this.state.skip)
      }, 500)
    })
  }



  _searchDateChange(e) {
    let trxDate = new Date(e)

    this.setState({
      searchDate: moment(trxDate),

      typingTimeout: setTimeout(() => {
        this._getData(this.state.skip)
      }, 500)
    })
  }

  _getData(skip) {
    this.setState({
      loading: true,
    });
    client.authenticate().then(() => {
      let searchObj = this.state.searchObj
      let queryString = ''

      if (this.state.searchDate !== '') {
        queryString = {
          trxDate: {
            $gte: new Date(moment(new Date(this.state.searchDate)).startOf('day')),
            $lte: new Date(moment(new Date(this.state.searchDate)).endOf('day')),
          }
        }
      }

      let query = {
        query: {
          companyId: this.props.commons.selectedCompany._id,
          $populate: 'propertyunitId dtledgerAccountId ctledgerAccountId',
          divisionType: 'SUPPLIER',
          $sort: {

            createdAt: -1
          },
          $limit: PAGESIZE,
          ...queryString,
          orRegex: this.state.searchObj
        }
      }
      _.assign(query.query, searchObj)

      return client.service('debitnotes').find(query)
    }).then((res) => {

      this.setState({
        loading: false,
      });

      this.props.fetchDebitNotes(res.data)
    }).catch((err) => {
      this.setState({
        loading: false,
      });
      console.log(err);
    });
  }

  handlePageChange = (page) => {

    this.setState({ CurrentPagination: page, loading: true });
    this.props.form.validateFields((err, values) => {

      client.authenticate().then((res) => {
        //
        return client.service('debitnotes').find({
          query: {
            ...values,
            divisionType: 'SUPPLIER',
            companyId: this.props.commons.selectedCompany._id,
            $limit: PAGESIZE,
            $skip: (page - 1) * PAGESIZE,
            $populate: 'propertyunitId dtledgerAccountId ctledgerAccountId',

            $sort: {

              createdAt: -1
            }
          }
        })
      }).then((res) => {
        //
        this.setState({ totalPagination: res.total, loading: false });
        this.props.fetchDebitNotes(res.data)
      }).catch((err) => {
        console.log(err);
      })
    });
  }

  handleSubmit() {

    if (this.props.debitnotes.mode === 'new') {
      this.setState({
        loading: true,
      });

      this.props.form.validateFields((err, values) => {

        if (!err) {

          values.trxDate = new Date(values.trxDate)

          client.authenticate()
            .then((res) => {
              return client.service('debitnotes').create({
                companyId: this.props.commons.selectedCompany._id,
                ...values,
              })
            })
            .then((res) => {

              this.props.updateMode('refresh')
              this.props.form.resetFields()
              this.setState({
                loading: false,
              });
            })
            .catch(err => { console.log(err) })
        }

      });

    }

    if (this.props.debitnotes.mode === 'edit') {


      this.props.form.validateFields((err, values) => {

        if (!err) {

          this.setState({
            loading: true,
          });

          values.trxDate = new Date(values.trxDate)

          client.authenticate()
            .then((res) => {
              return client.service('debitnotes').patch(this.props.debitnotes.activeId, {
                companyId: this.props.commons.selectedCompany._id,
                ...values,
              })
            })
            .then((res) => {

              this.props.updateMode('refresh')
              this.props.form.resetFields()
              this.setState({
                loading: false,
              });
            })
            .catch(err => { console.log(err) })
        }

      });

    }
  }


  getAccountList() {

    client.authenticate()
      .then((res) => {
        return client.service('ledger-accounts').find({
          query: {
            companyId: this.props.commons.selectedCompany._id,
            $sort: { accountName: 1 },
          }
        })
      })
      .then((res) => {

        this.setState({
          dtAccountList: res.data
        });

        return client.service('ledger-accounts').find({
          query: {
            companyId: this.props.commons.selectedCompany._id,
            $sort: { accountName: 1 },
          }
        })

      })
      .then((res) => {
        this.setState({
          ctAccountList: res.data
        });
      })

      .catch((err) => {
        console.log(err);
      });

  }

  //---------------------------------------------------------

  render() {
    const { getFieldDecorator } = this.props.form;

    const columns = [
      {
        title: (<Row gutter={8}>
          <Row>
            <Col span={24}>Reference No.</Col>
          </Row>
          <Row>
            <Col span={24}><Input value={this.state.searchReferenceNo} onChange={this._searchReferenceNoChange} /></Col>
          </Row>
        </Row>),
        dataIndex: 'referenceId',
        key: 'referenceId',
        width: '10%'
      },
      {
        title: 'Debit Account',
        dataIndex: 'dtledgerAccountId.description',
        key: 'dtledgerAccountId.description',
        width: '10%'
      },
      {
        title: 'Credit Account',
        dataIndex: 'ctledgerAccountId.description',
        key: 'ctledgerAccountId.description',
        width: '10%'
      }
      , {
        title: (<Row gutter={8}>
          <Row>
            <Col span={24}>Date</Col>
          </Row>
          <Row>
            <Col span={24}><DatePicker value={this.state.searchDate} onChange={this._searchDateChange} /></Col>
          </Row>
        </Row>),
        dataIndex: 'trxDate',
        key: 'trxDate',
        width: '10%',
        render: (text, record) => (<div>{moment(record.trxDate).format('DD-MM-YYYY')}</div>)
      }, {
        title: (<Row><Col style={{ 'float': 'right' }}>Amount</Col></Row>),
        dataIndex: 'debitAmount',
        key: 'debitAmount',
        width: '10%',
        render: (text, record) => (<div style={{
          float: 'right'
        }}>
          {parseFloat(record.debitAmount).toFixed(2)}
        </div>)
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
        key: 'remark',
        width: '10%',
        render: (text, record) => (
          <div style={{ textAlign: 'center' }}>
            {text ? <Popover content={text}><Icon type="message" /></Popover> : ''}
          </div>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        width: '40%',
        render: (text, record) => (<div>

          <Link to={{
            pathname: `/debitnotesSupplier/print/${record._id}`
          }}>
            <Button type="primary">Print</Button>
          </Link>

          <Divider type="vertical" />

          <Button onClick={() => { this.handleEdit(record._id); }} type="primary">Edit</Button>

          <Divider type="vertical" /> {this.renderConfirmDeleteBtn(record._id)}
        </div>)
      }
    ];

    return (<Layout>
      <Spin key='spinning' spinning={this.state.loading}>
        <Card title='Supplier Debit Notes' key='cardaction' extra={[
          <Button type="primary" onClick={() => this.showModal()} style={{ right: 10 }}>New</Button>
        ]}>



          <Table dataSource={this.props.debitnotes.debitnotes} columns={columns} rowKey="_id" pagination={{
            defaultCurrent: 1,
            total: this.state.totalPagination,
            onChange: this.handlePageChange,
            pageSize: PAGESIZE
          }} size={'small'} />


          <DebitNotesForm />
        </Card>
      </Spin>
    </Layout>)
  }
}

function mapStateToProps(state) {
  return {
    debitnotes: state.debitnotes,
    commons: state.commons
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchDebitNotes: fetchDebitNotes,
    pushDebitNotes: pushDebitNotes,
    removeDebitNotes: removeDebitNotes,
    updateActiveDebitNotes: updateActiveDebitNotes,
    updateDebitNotes: updateDebitNotes,
    updateMode: updateMode
  }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(DebitNotesIndex)));
